import { useState } from 'react';
import { ReactComponent as InstagramIconHover } from 'src/images/svgs/public-profile/social/instagram-hover.svg';
import { ReactComponent as XIcon } from 'src/images/svgs/public-profile/social/x.svg';
import { ReactComponent as InstagramIcon } from 'src/images/svgs/public-profile/social/instagram.svg';
import { ReactComponent as LinkedInIcon } from 'src/images/svgs/public-profile/social/linkedin.svg';
import { ReactComponent as WebsiteIcon } from 'src/images/svgs/public-profile/social/website.svg';
import { ReactComponent as XIconHover } from 'src/images/svgs/public-profile/social/x-hover.svg';
import { ReactComponent as LinkedInIconHover } from 'src/images/svgs/public-profile/social/linkedin-hover.svg';
import { ReactComponent as WebsiteIconHover } from 'src/images/svgs/public-profile/social/website-hover.svg';
import { ReactComponent as GithubIconHover } from 'src/images/svgs/public-profile/social/github-hover.svg';
import { ReactComponent as GithubIcon } from 'src/images/svgs/public-profile/social/github.svg';
import { StyledIconContainer, StyledIconsWrapper } from './social-media.styles';
import { SocialMediaProps, SocialMediaTypes } from './social-media.types';
import { BASE_GITHUB_URL, BASE_INSTAGRAM_URL, BASE_LINKEDIN_URL, BASE_X_URL } from './social-media.constants';
const ensurePersonalWebsiteProtocol = (url: string): string => /^https?:\/\//i.test(url) ? url : `https://${url}`;
const getInstagramProfile = (username: string): string => `${BASE_INSTAGRAM_URL}${username}`;
const getGithubProfile = (username: string): string => `${BASE_GITHUB_URL}${username}`;
const getXProfile = (username: string): string => `${BASE_X_URL}${username}`;
const getLinkedinProfile = (username: string): string => `${BASE_LINKEDIN_URL}${username}`;
export const SocialMedia = ({
  x,
  linkedin,
  instagram,
  github,
  website
}: SocialMediaProps) => {
  const [iconHover, setIconHover] = useState<SocialMediaTypes | null>(null);
  return <StyledIconsWrapper data-sentry-element="StyledIconsWrapper" data-sentry-component="SocialMedia" data-sentry-source-file="social-media.tsx">
      {x && <a href={getXProfile(x)} target="_blank" rel="noreferrer" aria-label="x-icon" id="x-icon" data-testid="x-icon">
          <StyledIconContainer onMouseEnter={() => setIconHover(SocialMediaTypes.X)} onMouseLeave={() => setIconHover(null)}>
            {iconHover === SocialMediaTypes.X ? <XIconHover data-testid="x-icon-hover" /> : <XIcon />}
          </StyledIconContainer>
        </a>}
      {linkedin && <a href={getLinkedinProfile(linkedin)} target="_blank" rel="noreferrer" aria-label="linkedin-icon" id="linkedin-icon" data-testid="linkedin-icon">
          <StyledIconContainer onMouseEnter={() => setIconHover(SocialMediaTypes.LINKEDIN)} onMouseLeave={() => setIconHover(null)}>
            {iconHover === SocialMediaTypes.LINKEDIN ? <LinkedInIconHover /> : <LinkedInIcon />}
          </StyledIconContainer>
        </a>}
      {instagram && <a href={getInstagramProfile(instagram)} target="_blank" rel="noreferrer" aria-label="instagram-icon" id="instagram-icon" data-testid="instagram-icon">
          <StyledIconContainer onMouseEnter={() => setIconHover(SocialMediaTypes.INSTAGRAM)} onMouseLeave={() => setIconHover(null)}>
            {iconHover === SocialMediaTypes.INSTAGRAM ? <InstagramIconHover /> : <InstagramIcon />}
          </StyledIconContainer>
        </a>}
      {github && <a href={getGithubProfile(github)} target="_blank" rel="noreferrer" aria-label="github-icon" id="github-icon" data-testid="github-icon">
          <StyledIconContainer onMouseEnter={() => setIconHover(SocialMediaTypes.GITHUB)} onMouseLeave={() => setIconHover(null)}>
            {iconHover === SocialMediaTypes.GITHUB ? <GithubIconHover /> : <GithubIcon />}
          </StyledIconContainer>
        </a>}
      {website && <a href={ensurePersonalWebsiteProtocol(website)} target="_blank" rel="noreferrer" aria-label="website-icon" id="website-icon" data-testid="website-icon">
          <StyledIconContainer onMouseEnter={() => setIconHover(SocialMediaTypes.WEBSITE)} onMouseLeave={() => setIconHover(null)}>
            {iconHover === SocialMediaTypes.WEBSITE ? <WebsiteIconHover /> : <WebsiteIcon />}
          </StyledIconContainer>
        </a>}
    </StyledIconsWrapper>;
};